import React from 'react'

// A chart needs a box of its own height to fill; the canvas has no text, so
// the box names it (the tiles and the tables hold the same numbers).
export const ChartBox = ({ label, height = 260, children }) =>
  <div style={{ height }} role="img" aria-label={label}>
    {children}
  </div>
